/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.recommendations.rpc.curated.CuratedRecommendationsService
 */
import * as References from './CuratedRecommendationsService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.recommendations.rpc.curated.CuratedRecommendationsService#getCuratedRecommendations
 */
export const GET_CURATED_RECOMMENDATIONS_QUERY_FIELD_NAME = 'com_hubspot_academy_recommendations_rpc_curated_CuratedRecommendationsService_getCuratedRecommendations';
export const GET_CURATED_RECOMMENDATIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_CURATED_RECOMMENDATIONS_QUERY_FIELD_NAME,
  args: ['language', 'size'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getCuratedRecommendationsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});